// extracted by mini-css-extract-plugin
module.exports = {"ant-input":"Contact_ant-input__1iciM"};